import { Box, Typography, useMediaQuery } from '@mui/material';
import { styles } from './styles';
import { Apple, Add } from '@mui/icons-material';
import GooglePlayIcon from '@/assets/google-play-icon.svg';
import QRCode from '@/assets/qr_code.png';
import QRCodeQA from '@/assets/qr_code_qa.png';
import Button from '@/components/button/Button';
import { theme } from '@/styles/theme';
import { useTranslation } from 'react-i18next';

interface BannerAppProps {
  sx?: any;
  hideScheduleButton?: boolean;
  onScheduleClick: () => void;
}

export const BannerApp = ({
  sx,
  onScheduleClick,
  hideScheduleButton,
}: BannerAppProps) => {
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const { t } = useTranslation(['banner', 'home']);

  const QRCodeURL = import.meta.env.MODE !== 'staging' ? QRCode : QRCodeQA;

  const appIcons = (
    <Box sx={styles.iconContainer}>
      <Box
        sx={styles.storeBox}
        onClick={() =>
          window.open(
            'https://play.google.com/store/apps/details?id=com.medstation.medstation'
          )
        }
      >
        <Box src={GooglePlayIcon} component="img" sx={styles.playStoreStyle} />
        <Box sx={styles.iconTexts}>
          <Typography sx={styles.iconTitle}>
            {t('banner:banner_available_in_masc')}
          </Typography>
          <Typography sx={styles.iconDescription}>
            {t('banner:banner_google_play')}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={styles.storeBox}
        onClick={() =>
          window.open(
            'https://apps.apple.com/br/app/medstation-app/id6743131481'
          )
        }
      >
        <Apple sx={styles.appleStyle} />
        <Box sx={styles.iconTexts}>
          <Typography sx={styles.iconTitle}>
            {t('banner:banner_available_in_masc')}
          </Typography>
          <Typography sx={styles.iconDescription}>
            {t('banner:banner_app_store')}
          </Typography>
        </Box>
      </Box>
    </Box>
  );

  const qrCodeCard = (
    <Box sx={styles.qrCodeContainer}>
      <Box sx={styles.qrCodeCard}>
        <Typography sx={styles.qrCodeTitle}>
          {t('banner:banner_scan_qr_code')}
        </Typography>
        <Box src={QRCodeURL} component="img" sx={styles.qrCode}></Box>
      </Box>
    </Box>
  );

  const scheduleAppointmentButton = (
    <Button
      sx={styles.scheduleButton}
      startIcon={<Add />}
      title={t('home:schedule_consultation')}
      onClick={onScheduleClick}
    />
  );

  const web = (
    <Box sx={styles.content}>
      <Box sx={styles.leftContent}>
        <Typography sx={styles.title}>{t('banner_title')}</Typography>
        <Typography sx={styles.description}>
          {t('banner:banner_description')}
        </Typography>
        {appIcons}
      </Box>
      {qrCodeCard}
    </Box>
  );

  const mobile = (
    <Box sx={styles.content}>
      <Typography sx={styles.title}>{t('banner:banner_title')}</Typography>
      <Typography sx={styles.description}>
        {t('banner:banner_description')}
      </Typography>
      <Box sx={styles.bottomContent}>
        {qrCodeCard}
        {appIcons}
      </Box>
    </Box>
  );

  return (
  <Box sx={[styles.bannerView, sx]}>
    {!isSmallScreen && !hideScheduleButton && (
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        {scheduleAppointmentButton}
      </Box>
    )}

    <Box sx={{ ...styles.container }}>{isSmallScreen ? mobile : web}</Box>
  </Box>
  );
};
